import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { EventDoc, EventMediaItem } from '../../models/event.model';
import {
  formatEventDateRange,
  formatEventTimeRange,
  hasPromotion,
  heroMedia,
} from '../event-utils';

/**
 * The all-events list row — iOS `EventVerticalCardView`.
 *
 * A fixed-height framed image with the price pill notched into its corner, over a title and a
 * date/time line. Unlike the featured card this one is full-width and sizes itself.
 */
@Component({
    selector: 'app-event-vertical-card',
    templateUrl: './event-vertical-card.component.html',
    styleUrls: ['./event-vertical-card.component.scss'],
    host: { class: 'events-scope' },
    standalone: false
})
export class EventVerticalCardComponent {
  @Input() event!: EventDoc;
  @Input() showBusinessInfo = false;

  @Output() openEvent = new EventEmitter<string>();
  @Output() addToCalendar = new EventEmitter<EventDoc>();

  constructor(private languageService: LanguageService) {}

  get media(): EventMediaItem | null {
    return heroMedia(this.event);
  }

  get hasPromotion(): boolean {
    return hasPromotion(this.event);
  }

  get date(): string {
    return formatEventDateRange(this.event, this.languageService.getCurrentLang());
  }

  get time(): string {
    return formatEventTimeRange(this.event);
  }

  onOpen(): void {
    if (this.event?.id) {
      this.openEvent.emit(this.event.id);
    }
  }

  onCalendar(mouseEvent: Event): void {
    mouseEvent.stopPropagation();
    this.addToCalendar.emit(this.event);
  }
}
